import React, { Component } from 'react';
import DocumentMeta from 'react-document-meta';
import Offers from './offers';
import { getOffers, isLoaded } from '../redux/modules/loan';

class Consumerloan extends Component {
  static fetchData({ getState, dispatch }) {
    if (!isLoaded({ getState })) {
      return dispatch(getOffers());
    }
  }

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <DocumentMeta canonical={`/${encodeURI('forbrugslån')}`} extend>
        <Offers
          {...this.props}
          filters={{ quickloan: false }}
          category="consumerloan"
        />
      </DocumentMeta>
    );
  }
}

export default Consumerloan;
